﻿import React from 'react';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

const Checkbox = ({ error, isChanged, isUsed, ...allProps }) => {
    const { displayname, layout, theme, customwidth, mobilePaddingRight, marginbottom, smallLabel, labelAsInline, children, ...props } = { ...allProps };

    return (
        <CheckboxWrapper layout={layout} theme={theme} displayname={displayname} customwidth={customwidth} labelAsInline={labelAsInline} smallLabel={smallLabel} mobilePaddingRight={mobilePaddingRight} marginbottom={marginbottom}>
            <input {...props} {...(isChanged && isUsed && error ? {
                className: `is-invalid-input ${props.className}`
            } : { className: props.className })} />
            <label htmlFor={props.id}>
                {theme !== 'big' && displayname}
                {theme === 'big' && <span class="visually-hidden">{displayname}</span> }
            </label>
            {children}
            {isChanged && isUsed && error}
        </CheckboxWrapper>
    );
};

const propsToExclude = ['layout', 'theme', 'displayname', 'customwidth', 'labelAsInline', 'smallLabel', 'mobilePaddingRight', 'marginbottom'];

const CheckboxWrapper = styled.div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !propsToExclude.includes(prop)
})`
    position: ${props => props.layout ? props.layout : 'relative'};
    ${'' /* line-height: 1; */}

    ${props => props.customwidth ? `
        ${mediaQuery.small(`
            width: ${props.customwidth};
        `)}
        ` : ''
    }
    ${props => props.mobilePaddingRight ? `
        ${mediaQuery.small(`
            padding-right: ${props.mobilePaddingRight};
        `)}
        ` : ''
    }

    ${props => props.layout === 'absolute' ?
        `top: 50%;
         transform: translateY(-50%)` : ''
    };

    ${mediaQuery.small(`
        position: relative;
        top: 0%;
        transform: none;
    `)}

    padding-left: 30px;

    input {
        position: absolute;
        opacity: 0;
    }

    input + label {
        position: relative;
        cursor: pointer;
        padding: 0;
        hyphens: auto;
        display: block;
        width: 100%;
        color: ${definitions.colors.almostBlack};
        
        ${props => props.labelAsInline ? `
            display: inline;
            width: auto;
        ` : ''}

        ${props => props.smallLabel ? `
            font-size: 14px;
            line-height: 17px;
            padding-top: 4px;
            color: ${definitions.colors.grayText};
            ${mediaQuery.small(`
                padding-top: 0px;
            `)}

            ` : ''
        }
    }

    input:focus:not(:checked) + label:before {
        outline: rgb(59, 153, 252) auto 5px;
    }

    input:checked + label:after {
        position: absolute;
        ${iconCode.check()}
        color: ${definitions.colors.green};

        left: -26px;
        top: 14px;
        transform: translateY(-50%);
        font-size: 11px;

        ${mediaQuery.small(`
            top: 8px;
        `)}
    }

    label:before {
        display: block;
        content: '';
        position: absolute;

        top: 3px;
        left: -30px;

        vertical-align: text-top;
        

        width: 20px;
        height: 20px;

        background: #f5f4f4;
        border: 1px solid #c5c9cc;
        border-radius: 4px;

        ${mediaQuery.small(`
            top: -2px;
        `)}

        ${props => props.marginbottom ? `
            ${mediaQuery.small(`
                margin-bottom: ${props.marginbottom};
            `)}
        ` : `
            ${mediaQuery.small(`
                margin-bottom: 5px;
            `)}
        `
        }
    }

    // theme: big
    ${props => props.theme === 'big' ? `
        position: relative;
        // min-height: 150px;
        display: inline-block;
        
        padding-left: 0;

        &:not(:first-of-type) {
            padding-left: 10px !important;
        }

        // ${mediaQuery.small(`
        //     min-height: 103px;
        // `)}

        label:before {
            display: inline-block;
            content: '${props.displayname}';
            position: relative;

            top: 0;
            left: 0;

            width: auto;
            height: auto;
            // max-height: 70px;
            padding: 34px 53px;
            margin-bottom: 26px;
            margin-right: 10px;

            line-height: 1;
            font-family: ${definitions.fonts.heading};
            font-size: 22px;
            font-weight: bold;
            color: ${definitions.colors.almostBlack};

            background: transparent;
            border: none;
            border-radius: 0;
            outline: 1px solid ${definitions.colors.grayBorder};

            transition: outline 150ms ease-out, color 150ms ease-out;

            ${mediaQuery.small(`
                padding: 10px 15px 10px 15px;
                font-size: 20px;
                margin-bottom: 15px;
            `)}

            // display: inline-block;
            // content: '${props.displayname}';
            //
            // width: auto;
            // height: auto;
            // padding: 34px 53px;
            // margin-bottom: 26px;
            // margin-right: 10px;
            //
            // font-family: ${definitions.fonts.heading};
            // font-size: 22px;
            // font-weight: bold;
            // color: ${definitions.colors.almostBlack};
            //
            // border-radius: 0;
            // background: transparent;
            // border: none;
            //
            // outline: 1px solid ${definitions.colors.grayBorder};
            // transition: outline 150ms ease-out, color 150ms ease-out, box-shadow none;
            //
            // ${mediaQuery.small(`
            //     min-width: 200px;
            //     // padding: 17px 24px;
            //     padding: 10px 20px;
            //     font-size: 20px;
            //     margin-bottom: 15px;
            // `)}
        }

        input[type=radio]:focus:not(:checked) + label:before {
            box-shadow: inset 0px 0px 1px 1px rgb(59, 153, 252);
        }

        input:checked + label:before {
            outline: 3px solid ${definitions.colors.green};
            color: ${definitions.colors.green};
        }

        input:checked + label:after {
            display: none;
        }

        .form-error {
            text-align: left;
            margin-top: 10px;
        }` : ''
    }
`;

export default control(Checkbox);
